"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var _cache = {};

function updateList(groups) {
  lodash_1.default.forEach(groups, function (group) {
    updateOne(group);
  });
}

exports.updateList = updateList;

function updateOne(group) {
  if (!group) {
    console.warn("group is null ".concat(group));
    return;
  }

  var id = group.id;
  _cache[id] = group;
}

exports.updateOne = updateOne;

function getById(groupId) {
  return _cache[groupId];
}

exports.getById = getById;

function getByIds(groupIds) {
  var groups = [];
  lodash_1.default.forEach(groupIds, function (id) {
    var group = _cache[id];

    if (group) {
      groups.push(group);
    }
  });
  return groups;
}

exports.getByIds = getByIds;

function removeById(groupId) {
  delete _cache[groupId];
}

exports.removeById = removeById;

function clear() {
  _cache = {};
}

exports.clear = clear;